import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { User } from 'src/app/shared/models/security/user';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_BENEFICIAIRE, PARAM_LABEL_USER } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import {
	CompetenceElementaireSESSAD,
	CompetenceSAAD,
	CompetenceSSIAD
} from 'src/app/shared/enums/competence.enum';
import { Subject, debounceTime, take } from 'rxjs';
import { LogService } from 'src/app/core/services/log/log.service';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { UserModalAjoutFormComponent } from '../modal/user-modal-ajout-form/user-modal-ajout-form.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-user',
	templateUrl: './list-user.component.html',
	styleUrls: ['./list-user.component.scss']
})
export class ListUsersComponent implements OnInit {
	users: User[];
	currentPage = 1;

	userCsvFile: File = null;
	sortType = 'lastName';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	competences: Record<string, string>;

	searchedInput = '';

	// nombre de page totale pour la pagination
	totalItems: number = 0;
	itemsPerPage = 10;

	user: User = null;
	isPlanif = false;
	labelUserCapitalized: string;
	labelUserPluralized: string;

	ajoutUserModalref: BsModalRef;

	isAddable = false;
	isImportable = false;
	isExportable = false;

	isMobile = false;
	screenWidth: number;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive: boolean;

	isListingLoading: boolean = true;

	private searchSubject = new Subject<string>();

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {
		// ajout de délai à la saisie de recherche pour ne pas bombarder le back de requête
		this.searchSubject
			.pipe(
				debounceTime(300) // Délai en millisecondes
			)
			.subscribe(() => {
				this.searchByInput();
			});
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.labelUserCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_USER
			);
		this.labelUserPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_USER
			);

		this.user = this.facade.dataStorageService.getUser();

		this.competences = this.isSESSAD
			? CompetenceElementaireSESSAD
			: this.isSAAD
			? CompetenceSAAD
			: CompetenceSSIAD;

		this.isExportable = false;
		this.isAddable = true;
		this.isImportable = false;

		this.getUsersMinimal();
	}

	getUsersMinimal(): void {
		this.isListingLoading = true;
		this.facade.userService.getUsersMinimal()
			.subscribe({
				next: (val) => {
					this.users = val;
					this.totalItems = this.users.length >= 8 ? 10 : 8;
				},
				error: (err: ErrorResponse) => {
					this.logger.error(err + '');
				},
				complete: () => {
					this.isListingLoading = false;
				}
			});
	}

	selectUser(user: User): void {
		const link = ['/gestion/users', user.id];
		this.router.navigate(link);
	}

	importUsers(event: any): void {
		this.isImportable = false;
		this.userCsvFile = event.target.files[0];
		this.facade.userService
			.importUsers(this.userCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.facade.toastService.createSuccessToast('Import effectué');
					this.getUsersMinimal();
					this.isImportable = true;
				},
				error: (err: ErrorResponse) => {
					this.isImportable = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	exportUsers(): void {
		this.facade.exportService
			.exportUsers()
			.subscribe((blob) => saveAs(blob, 'user.csv'));
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	onKeyUp() {
		this.searchSubject.next(this.searchedInput);
	}

	searchByInput() {
		this.currentPage = 1;
		//this.getUsersMinimal();
		//this.users = this.users.filter(x => x.lastName === this.searchedInput || x.firstName === this.searchedInput);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		// const initialState = {
		// 	serviceCenter: this.user.employee.serviceCenter
		// };
		// if (this.user === null || this.user.employee.serviceCenter === null) {
		// 	this.facade.toastService.createErrorToast(
		// 		"Vous n'êtes pas rattaché à un centre."
		// 	);
		// } else {
			this.ajoutUserModalref = this.modalService.show(
				UserModalAjoutFormComponent,
				{
					class: 'modal-lg',
					//initialState,
					backdrop: 'static'
				}
			);
			this.ajoutUserModalref.content.updateListing
				.pipe(take(1))
				.subscribe((addedUser: User) => {
					this.users.push(addedUser);
				});
		//}
	}

	pageHasChanged(pageNumber: any) {
		this.currentPage = pageNumber;

		this.getUsersMinimal();
	}
}
